import "./contact.css";
import heroImg from "../../assets/contact/contact-hero.jpg";

export default function Contact() {
  return (
    <div className="contact-page">
      
      {/* HERO */}
      <section
        className="contact-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="contact-hero-overlay">
          <h1>Contact Elvara Signatures</h1>
          <p>Let’s design your space with purpose & precision</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="contact-content">
        <div className="contact-wrapper">

          {/* LEFT */}
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>We’d love to hear about your project.</p>

            <div className="info-item">
              <strong>📍 Address</strong>
              <span>Gala No. B-15, Navjeevan Industrial Estate
Opp. Dhuri Resort, Waliv
Vasai (E) - 401208</span>
            </div>

            <div className="info-item">
              <strong>📞 Phone</strong>
              <span>+91 8625922952 , +91 7709008353</span>
            </div>

            <div className="info-item">
              <strong>✉️ Email</strong>
              <span>elvarasignatures@gmail.com</span>
            </div>
          </div>

          {/* RIGHT */}
          <form className="contact-form">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input type="tel" placeholder="Phone Number" />
            <textarea placeholder="Your Message" rows="5"></textarea>
            <button type="submit">Send Message</button>
          </form>

        </div>
      </section>
    </div>
  );
}